//TODO: this list can be extended to make check for input component more bulletproof
const inputComponentDistinctProperties = [
  'validity',
  'updateValidityIndication',
  'onChange'
]

module.exports = component =>
  inputComponentDistinctProperties.every(
    inputProperty => inputProperty in component
  )
